<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">
              Nomor
              <i
                :class="
                  currentSort === 'nomor'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('jenis_usaha')">
              Jenis Usaha
              <i
                :class="
                  currentSort === 'jenis_usaha'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('bidang')">
              Bidang
              <i
                :class="
                  currentSort === 'bidang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('sub_bidang')">
              Sub Bidang
              <i
                :class="
                  currentSort === 'sub_bidang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kualifikasi')">
              Kualifikasi
              <i
                :class="
                  currentSort === 'kualifikasi'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.jenis_usaha }}</td>
            <td>{{ list.bidang }}</td>
            <td>{{ list.sub_bidang }}</td>
            <td>{{ list.kualifikasi }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <EditForm
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    EditForm: () => import('@/views/MasterData/Edit/LegalDoc/IUJPTL.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: 0,
        jenis_usaha: '',
        bidang: '',
        sub_bidang: '',
        kualifikasi: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          nomor: 1,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Uap',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          nomor: 2,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Gas',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          nomor: 3,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Gas-Uap',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          nomor: 4,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Panas Bumi',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          nomor: 5,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Air',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          nomor: 6,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Air Skala Kecil dan Menengah',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          nomor: 7,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Diesel',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          nomor: 8,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Nuklir',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          nomor: 9,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang:
            'Pembangkit Listrik Tenaga Energi Baru Lainnya dan Tenaga Energi Terbarukan Lainnya',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          nomor: 10,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Transmisi Tenaga Listrik',
          sub_bidang:
            'Jaringan Transmisi Tenaga Listrik Tegangan Tinggi dan/atau Tegangan Ekstra Tinggi',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          nomor: 11,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Transmisi Tenaga Listrik',
          sub_bidang: 'Gardu Induk',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
        {
          nomor: 12,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Distribusi Tenaga Listrik',
          sub_bidang: 'Jaringan Distribusi Tenaga Listrik Tegangan Menengah',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 12',
        },
        {
          nomor: 13,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Distribusi Tenaga Listrik',
          sub_bidang: 'Jaringan Distribusi Tenaga Listrik Tegangan Rendah',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 13',
        },
        {
          nomor: 14,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Instalasi Pemanfaatan Tenaga Listrik',
          sub_bidang: 'Instalasi Pemanfaatan Tenaga Listrik Tegangan Tinggi',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 14',
        },
        {
          nomor: 15,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Instalasi Pemanfaatan Tenaga Listrik',
          sub_bidang: 'Instalasi Pemanfaatan Tenaga Listrik Tegangan Menengah',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 15',
        },
        {
          nomor: 16,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Instalasi Pemanfaatan Tenaga Listrik',
          sub_bidang: 'Instalasi Pemanfaatan Tenaga Listrik Tegangan Rendah',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: '-',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        jenis_usaha: data.jenis_usaha,
        sub_bidang: data.sub_bidang,
        bidang: data.bidang,
        kualifikasi: data.kualifikasi,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    iujptlData() {
      const result = this.$store.state.mdDatabaseStore.iujptlData
      return result
    },
    sortedData() {
      return this.iujptlData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
